module.exports = __webpack_public_path__ + "media/images/challenges-track-a6bc6b4350c0b39bf3f45d217f1f8dc0.jpg";